module.exports = "varying vec3 vPosition;\n\nvoid main() {\n    vPosition = position;\n    gl_Position = vec4(position, 1.0);\n}"